<template>
  <Perspective />
</template>

<script>
import Perspective from "./components/Perspective";

export default {
  name: "App",
  components: {
    Perspective,
  },
};
</script>
